import { orderRequestConstructor } from '@monorepo/orders';
import { OrderService } from '@spilca/order_ts/v1/order_web/order_web_pb_service';

const getOrders = (filter: object | null) =>
  orderRequestConstructor(filter, OrderService.ListOrder);

export default getOrders;
